import { useEffect, useRef, useState } from "react";

function prefersReducedMotion() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

// Fixed, full-page background loop. Sits behind everything (z-0). Only visible
// through sections given a translucent background (see .v2-stage in index.css);
// opaque sections (hero, logos, card grids) cover it.
export default function V2Background() {
  const ref = useRef(null);
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    setReduced(prefersReducedMotion());
  }, []);

  useEffect(() => {
    const v = ref.current;
    if (v && !reduced) v.play().catch(() => {});
  }, [reduced]);

  if (reduced) return null;

  return (
    <div className="fixed inset-0 z-0 pointer-events-none" aria-hidden="true">
      <video
        ref={ref}
        className="absolute inset-0 w-full h-full object-cover"
        muted
        playsInline
        autoPlay
        loop
        preload="auto"
        disablePictureInPicture
      >
        <source src="/media/bg-drift.mp4" type="video/mp4" />
      </video>
    </div>
  );
}
